import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useState } from "react"
import { Row, Col, CardBody, Card, Alert, Container, Form, FormFeedback, Modal } from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import { useFormik } from "formik"

import { apiError, loginUser } from "../../../store/actions"
import logo from "assets/images/logo-dark.svg"
import { PrimaryButton } from "components/PrimaryButton/PrimaryButton"
import { SecondaryButton } from "components/SecondaryButton/SecondaryButton"
import { Register } from "../Register/Register"
import { SocialsBlock } from "../components/SocialsBlock/SocialsBlock"
import { loginValidationSchema } from "./Login.helpers"
import { InputField } from "components/InputField/InputField"
import ForgetPassword from "../ForgetPassword/ForgetPassword"

const Login = props => {
  const dispatch = useDispatch()

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: loginValidationSchema,
    onSubmit: values => {
      dispatch(apiError(""))
      dispatch(loginUser(values, props.history))
    },
  })

  const { error } = useSelector(state => ({
    error: state.Login.error,
  }))

  // handleValidSubmit
  const handleValidSubmit = (event, values) => {
    dispatch(apiError(""))
    dispatch(loginUser(values, props.history))
  }

  const [isModalOpened, setIsModalOpened] = useState(false)
  const [enabledLogin, setEnabledLogin] = useState(true)

  const openModal = opened => {
    setIsModalOpened(opened)
  }

  const onFormSubmit = e => {
    e.preventDefault()
    validation.handleSubmit()
  }

  return (
    <React.Fragment>
      <MetaTags>
        <title>Login | Investium</title>
        <script
          dangerouslySetInnerHTML={{
            __html: `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-TTS77QJ');
      `,
          }}
        ></script>
      </MetaTags>
      <div className="position-relative overflow-hidden d-flex login">
        <svg
          className="position-absolute login__image"
          width="1221"
          height="1080"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity=".04"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M45.4109 18.2188-188.994 81.0275c-16.542 4.4325-26.354 21.4565-21.914 38.0245l62.009 231.423c5.708 21.302-6.906 43.191-28.175 48.889l-217.291 58.223c-16.542 4.433-26.353 21.457-21.914 38.025L-195.8 1318.45c4.439 16.57 21.448 26.41 37.99 21.97l231.0599-61.91c16.5422-4.43 26.3533-21.46 21.9139-38.02L-124.417 421c-5.708-21.302 6.907-43.191 28.1752-48.889l213.9438-57.327c21.269-5.699 43.137 6.95 48.845 28.252l175.944 656.633c4.44 16.571 21.449 26.411 37.991 21.971l222.502-59.617c21.268-5.698 43.137 6.95 48.845 28.252l61.904 231.035c4.44 16.57 21.449 26.4 37.991 21.97l234.405-62.81c16.541-4.43 26.351-21.45 21.911-38.02l-61.902-231.035c-5.708-21.302 6.907-43.19 28.175-48.889l219.157-58.723c16.54-4.432 26.35-21.457 21.91-38.025L994.905-57.0585c-4.44-16.5681-21.449-26.4061-37.991-21.9736L725.855-17.1199c-16.543 4.4325-26.354 21.4568-21.914 38.0249L923.417 840c5.708 21.302-6.907 43.191-28.175 48.89l-213.944 57.326c-21.269 5.699-43.137-6.95-48.845-28.252l-175.84-656.242c-4.439-16.568-21.448-26.406-37.99-21.974l-224.367 60.119c-21.269 5.699-43.137-6.95-48.845-28.252L83.4014 40.1924C78.962 23.6243 61.953 13.7864 45.4109 18.2188ZM-190.143 76.7419c-18.905 5.0657-30.118 24.5221-25.044 43.4571l62.009 231.423c5.074 18.935-6.139 38.391-25.044 43.457l-217.291 58.223c-18.905 5.066-30.118 24.522-25.045 43.457l220.479 822.841c5.074 18.93 24.512 30.17 43.418 25.11l231.0593-61.91c18.9052-5.07 30.1177-24.53 25.0444-43.46L-120.138 419.853c-5.074-18.935 6.139-38.391 25.0445-43.457L118.851 319.07c18.905-5.066 38.344 6.178 43.417 25.113l175.945 656.637c5.073 18.93 24.512 30.17 43.417 25.11l222.502-59.621c18.905-5.066 38.344 6.178 43.418 25.113l61.904 231.028c5.074 18.94 24.513 30.18 43.418 25.12l234.405-62.81c18.903-5.07 30.123-24.52 25.043-43.46l-61.903-231.031c-5.074-18.935 6.139-38.392 25.044-43.457l219.159-58.723c18.9-5.066 30.12-24.522 25.04-43.457L999.184-58.205c-5.074-18.935-24.513-30.1784-43.418-25.1127l-231.06 61.9122c-18.905 5.0656-30.118 24.52205-25.044 43.4571L919.138 841.147c5.073 18.935-6.139 38.391-25.045 43.457L680.149 941.93c-18.905 5.066-38.344-6.178-43.417-25.113l-175.84-656.242c-5.074-18.935-24.512-30.178-43.418-25.113l-224.366 60.119c-18.906 5.066-38.345-6.177-43.418-25.112L87.6802 39.0459c-5.0736-18.935-24.5124-30.17833-43.4176-25.1127L-190.143 76.7419Z"
            fill="#3F3F45"
          />
        </svg>

        <Container fluid className="position-relative login__container">
          <Row className="align-items-start justify-content-center login__row">
            <Col md={12} lg={6} xl={6}>
              <div className="login__main">
                <div className="login__logo">
                  <img src={logo} alt="Logotype" title="Investium" className="login__logo-image" />
                </div>

                <h1 className="login__title">
                  Bringing together <span className="font-weight-semibold">like-minded</span> investors
                </h1>
              </div>
            </Col>

            <Col md={12} lg={4} xl={4}>
              <Card className="login__card">
                <CardBody className="login__card-body">
                  {enabledLogin ? (
                    <Form className="form-horizontal login__form" onSubmit={onFormSubmit}>
                      {error ? (
                        <Alert color="danger">
                          {error?.includes("user-not-found") ? "User not found, please try again!" : error}
                        </Alert>
                      ) : null}

                      <InputField
                        className="login__form-wrapper"
                        inputName="email"
                        type="email"
                        placeholder="Email"
                        value={validation.values.email || ""}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        invalid={validation.touched.email && validation.errors.email ? true : false}
                        error={
                          validation.touched.email && validation.errors.email ? (
                            <FormFeedback type="invalid" className="login__error-text font-size-11">
                              {validation.errors.email}
                            </FormFeedback>
                          ) : null
                        }
                      />

                      <InputField
                        className="login__form-wrapper"
                        inputName="password"
                        type="password"
                        placeholder="Password"
                        value={validation.values.password || ""}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        invalid={validation.touched.password && validation.errors.password ? true : false}
                        error={
                          validation.touched.password && validation.errors.password ? (
                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                          ) : null
                        }
                      />

                      <div className="login__form-wrapper">
                        <PrimaryButton
                          className="w-100 btn btn-primary btn-block login__submit-button"
                          type="submit"
                          text="Log In"
                        />
                      </div>

                      <div className="login__form-wrapper">
                        <SecondaryButton
                          className="w-100 btn btn-primary btn-block login__sign-up-button"
                          text="Create new account"
                          onClick={() => openModal(true)}
                        />
                      </div>

                      <SocialsBlock history={props.history} />

                      <button
                        className="position-absolute font-size-13 text-decoration-underline border-0 login__forgot-password"
                        onClick={() => setEnabledLogin(false)}
                      >
                        Forgot password?
                      </button>
                    </Form>
                  ) : (
                    <ForgetPassword history={props.history} onClick={() => setEnabledLogin(true)} />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        className="login__modal"
        centered={true}
        fade={false}
        isOpen={isModalOpened}
        toggle={() => openModal(false)}
      >
        <Register history={props.history} />
      </Modal>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
